import { render, staticRenderFns } from "./buyHeader.vue?vue&type=template&id=5adb791a&scoped=true"
import script from "./buyHeader.vue?vue&type=script&lang=js"
export * from "./buyHeader.vue?vue&type=script&lang=js"
import style0 from "./buyHeader.vue?vue&type=style&index=0&id=5adb791a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb791a",
  null
  
)

export default component.exports